import { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { EditRequest } from '../../../features/agent/AgentRequestSlice'
import Loading from '../../../Loading'
import Header from '../../../component/dashboard/Header'
import Input from '../../../component/form/Input'
import InputRef from '../../../component/form/InputRef'
import Select from '../../../component/form/Select'
import Button from '../../../component/form/Button'
import Message from '../../form/Message'
import Broadcast from "../../dashboard/Broadcast";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { host } from '../../../function/api'
import $ from 'jquery'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

function Edit() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const param = useParams()
    const {
        status,
        message,
        success,
        loading,
        agentRequestData,
    } = useSelector(state => state.agentRequest)


    const tp_karbari = useRef('')
    const tp_tip = useRef('')
    const cl_name = useRef('')
    const mt_model = useRef('')
    const tp_system = useRef('')
    const mt_bodyno = useRef('')
    const mt_motorno = useRef('')
    const mt_pelakno = useRef('')
    const mt_sanadno = useRef('')
    const tp_mehvar = useRef('')
    const tp_charkh = useRef('')
    const tp_zarfiyat = useRef('')
    const tp_cylandr = useRef('')
    const tp_sookht = useRef('')
    const tp_hajm = useRef('')
    const mt_pelakserial = useRef('')
    const mt_pelakdate = useRef('')


    const [numberType, setNumberType] = useState('mt_pelakno')
    const [number, setNumber] = useState('')
    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [father_name, setFatherName] = useState('')
    const [idcard, setIdcard] = useState('')
    const [mobile, setMobile] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [postalcode, setPostalcode] = useState('')
    const [birthplace, setBirthplace] = useState('')
    const [placeofissue, setPlaceofissue] = useState('')
    const [birthdaye, setbirthdaye] = useState()


    useEffect(() => {

        setNumber('');

    }, [numberType])

    useEffect(() => {


        const data = {
            'request_id': param.id,
            'access': localStorage.getItem('access')
        }

        dispatch(EditRequest(data));

    }, [param])

    useEffect(() => {
        if (status === false && message != "") {
            toast.error(message, {
                position: "top-center",
                autoClose: 1500,
                autoClose: 1500,
            })
        } else if (status === true && message != "") {
            toast.success(message, {
                position: "top-center",
            })            
        }

    }, [status, message, loading])

    useEffect(() => {
        if(typeof agentRequestData === 'object'){
            if(Object.keys(agentRequestData).length != 0 && status === true){
             setName(agentRequestData.customer_data.name);
             setFamily(agentRequestData.customer_data.family);
             setNationalCode(agentRequestData.customer_data.nationalCode);
             setFatherName(agentRequestData.customer_data.father_name);
             setIdcard(agentRequestData.customer_data.idcard);
             setMobile(agentRequestData.customer_data.mobile);
             setPhone(agentRequestData.customer_data.phone);
             setAddress(agentRequestData.customer_data.address);
             setPostalcode(agentRequestData.customer_data.postalcode);
             setBirthplace(agentRequestData.customer_data.birthplace);
             setPlaceofissue(agentRequestData.customer_data.placeofissue);
             setbirthdaye(agentRequestData.customer_data.birthdaye);
            } 
         }
    }, [status, agentRequestData])


    

    const RahpardaznetValidationNationalCode = (number) => {
        if (!/^\d{10}$/.test(number)) return false;
        const check = +number[9];
        const sum = number.split('').slice(0, 9).reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
        return sum < 2 ? check === sum : check + sum === 11;

    }


    const documentUpdateHandler = async (event) => {
        event.preventDefault()

        if (nationalCode.length != 11) {
            if (RahpardaznetValidationNationalCode(nationalCode) !== true) {
                toast.error("کدملی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        if (postalcode && postalcode.length > 1 && postalcode != " ") {

            let replacePostal = postalcode.replace(" ", "");
            if (replacePostal.length != 10) {
                toast.error("کدپستی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        let replaceMobile = mobile.replace(" ", "");
        console.log(replaceMobile);
        if (replaceMobile.length != 11) {
            toast.error("شماره موبایل باید 11 رقم باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return
        }


        const data = {
            'request_id': param.id,
            'tp_karbari': tp_karbari.current.innerHTML,
            'tp_tip': tp_tip.current.innerHTML,
            'cl_name': cl_name.current.innerHTML,
            'mt_model': mt_model.current.innerHTML,
            'tp_system': tp_system.current.innerHTML,
            'mt_bodyno': mt_bodyno.current.innerHTML,
            'mt_motorno': mt_motorno.current.innerHTML,
            'mt_pelakno': mt_pelakno.current.innerHTML,
            'mt_sanadno': mt_sanadno.current.innerHTML,
            'tp_mehvar': tp_mehvar.current.innerHTML,
            'tp_charkh': tp_charkh.current.innerHTML,
            'tp_zarfiyat': tp_zarfiyat.current.innerHTML,
            'tp_cylandr': tp_cylandr.current.innerHTML,
            'tp_sookht': tp_sookht.current.innerHTML,
            'tp_hajm': tp_hajm.current.innerHTML,
            'mt_pelakserial': mt_pelakserial.current.innerHTML,
            'mt_pelakdate': mt_pelakdate.current.innerHTML,

            // customer data
            'name': name ? name : null,
            'family': family ? family : null,
            'nationalCode': nationalCode ? nationalCode : null,
            'father_name': father_name ? father_name : null,
            'idcard': idcard,
            'mobile': mobile,
            'phone': phone ? phone : null,
            'address': address ? address : null,
            'postalcode': postalcode,
            'birthplace': birthplace,
            'placeofissue': placeofissue,
            'birthdaye': birthdaye,
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}agent/request/edit`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("درخواست شما با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                if (response.data.data > 0) {
                    navigate('/agent/request/edit/' + response.data.data)
                } else {
                    navigate('/agent/requests')
                }

            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
            })
        }
    }
    const children = ({ remainingTime }) => {
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60

        return `${minutes}:${seconds}`
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <Broadcast title='ویرایش درخواست نماینده' />
            


            {
                (typeof agentRequestData === 'object') ? (
                    (Object.keys(agentRequestData).length != 0 && status === true) ? (

                        <>
                           <div className='rahpardaznet-time-down-box'>
                           <CountdownCircleTimer
                                isPlaying
                                duration={agentRequestData.time_down}
                                colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                                colorsTime={[7, 5, 2, 0]}
                            >
                                {({ remainingTime }) =>
                                    
                                    <div className='text-center timer-text-size' >
                                        <div>تا پایان وقت ویرایش</div>
                                        <div className="rahpardaznet-time-down">{Math.floor(remainingTime / 60)}:{remainingTime % 60}</div>
                                        <div>باقی مانده است.</div>
                                    </div>
                                }
                            </CountdownCircleTimer>
                            </div>
                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                <Header title='اطلاعات کارخانه' />
                                <div
                                    className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                    <input type="hidden" ref={mt_sanadno} value={agentRequestData.mt_sanadno} />
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        {
                                            (agentRequestData.mt_pelakno != '0') ? (
                                                <div
                                                    className='d-flex flex-column justify-content-center align-items-center rahpardaznet-pelak rahpardaznet-pelak-box'>
                                                    <span
                                                        ref={mt_pelakserial}>{agentRequestData.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span ref={mt_pelakno}>
                                                        {agentRequestData.mt_pelakno}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div className='rahpardaznet-pelakno'>
                                                    <span className="d-none"
                                                        ref={mt_pelakserial}>{agentRequestData.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span className="d-none" ref={mt_pelakno}>
                                                        {agentRequestData.mt_pelakno}
                                                    </span>
                                                    <span className='text-danger'>بدون پلاک</span>
                                                </div>
                                            )
                                        }

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> تاریخ نصب : </label>
                                        <span ref={mt_pelakdate}>{agentRequestData.mt_pelakdate}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> شماره سند : </label>
                                        <span ref={mt_sanadno}>{agentRequestData.mt_sanadno}</span>
                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع کاربری : </label>
                                        <span ref={tp_karbari}>{agentRequestData.tp_karbari}</span>
                                    </li>

                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> سیستم : </label>
                                        <span ref={tp_system}>{agentRequestData.tp_system}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تیپ : </label>
                                        <span ref={tp_tip}>{agentRequestData.tp_tip}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> رنگ : </label>
                                        <span ref={cl_name}>{agentRequestData.cl_name}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> مدل : </label>
                                        <span ref={mt_model}>{agentRequestData.mt_model}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره بدنه : </label>
                                        <span className="font-style" ref={mt_bodyno}>
                                            {agentRequestData.mt_bodyno}
                                        </span>
                                        <button type="button" className="rahpardaznet-copy-button"
                                            data-name="شماره بدنه" data-text={agentRequestData.mt_bodyno}>کپی
                                        </button>

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره انجین : </label>
                                        <span className="font-style" ref={mt_motorno}>
                                            {agentRequestData.mt_motorno}
                                        </span>

                                        <button type="button" className="rahpardaznet-copy-button"
                                            data-name="شماره انجین" data-text={agentRequestData.mt_motorno}>کپی
                                        </button>

                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد محور : </label>
                                        <span ref={tp_mehvar}>{agentRequestData.tp_mehvar}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد چرخ : </label>
                                        <span ref={tp_charkh}>{agentRequestData.tp_charkh}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> ظرفیت : </label>
                                        <span ref={tp_zarfiyat}>{agentRequestData.tp_zarfiyat}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد سیلندر : </label>
                                        <span ref={tp_cylandr}>{agentRequestData.tp_cylandr}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع سوخت : </label>
                                        <span ref={tp_sookht}>{agentRequestData.tp_sookht}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> حجم سیلندر : </label>
                                        <span ref={tp_hajm}>{agentRequestData.tp_hajm}</span>
                                    </li>
                                </div>
                            </div>


                            <div className='row rahpardaznet-cart  my-5 '>
                                <Header title={'مشخصات خریدار'} />
                                <>
                                    <form>
                                        <div className="row">
                                            <div className="col-12 col-md-6 ">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor=""
                                                        className="text-end form-label px-1 ">
                                                        نام
                                                    </label>
                                                    <input
                                                        tabIndex="3"
                                                        type="text"
                                                        value={name ? name : null}
                                                        onChange={(e) => setName(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id=""
                                                        placeholder=""
                                                        autoFocus
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor=""
                                                        className="text-end form-label px-1 ">
                                                        نام خانوادگی
                                                    </label>
                                                    <input
                                                        tabIndex="4"
                                                        type="text"
                                                        value={family ? family : null}
                                                        onChange={(e) => setFamily(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id=""
                                                        placeholder=""
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="father_name"
                                                        className="text-end form-label px-1 ">
                                                        نام پدر
                                                    </label>
                                                    <input
                                                        tabIndex="5"
                                                        type="text"
                                                        value={father_name ? father_name : null}
                                                        onChange={(e) => setFatherName(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="father_name"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label
                                                        htmlhtmlFor="nationalCode"
                                                        className="text-end form-label px-1 ">
                                                        شماره/شناسه ملی
                                                    </label>
                                                    <input

                                                        tabIndex="6"
                                                        type="text"
                                                        value={nationalCode ? nationalCode : null}
                                                        onChange={(e) => setNationalCode(e.target.value)}
                                                        className="form-control shadow-none text-left"
                                                        id="nationalCode"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className='row m-3 d-flex flex-row justify-content-between rahpardaznet-form-controll'>
                                                    <label htmlhtmlFor="mobile"
                                                        className="text-end form-label px-1 d-flex justify-content-between">
                                                        تلفن همراه
                                                    </label>
                                                    <input

                                                        tabIndex="7"
                                                        type="text"
                                                        value={mobile ? mobile : null}
                                                        onChange={(e) => setMobile(e.target.value)}
                                                        className="form-control shadow-none text-left"
                                                        id="mobile"
                                                        placeholder=""
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="phone"
                                                        className="text-end form-label px-1 ">
                                                        تلفن
                                                    </label>
                                                    <input
                                                        tabIndex="8"
                                                        type="text"
                                                        value={phone ? phone : null}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        className="form-control shadow-none text-left"
                                                        id="phone"
                                                        placeholder=""
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="birthplace"
                                                        className="text-end form-label px-1 ">
                                                        محل تولد
                                                    </label>
                                                    <input
                                                        tabIndex="9"
                                                        type="text"
                                                        value={birthplace ? birthplace : null}
                                                        onChange={(e) => setBirthplace(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="birthplace"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="birthdaye"
                                                        className="text-end form-label px-1 ">
                                                        تاریخ تولد
                                                    </label>


                                                    <input
                                                        tabIndex="10"
                                                        type="text"
                                                        value={birthdaye ? birthdaye : null}
                                                        onChange={(e) => setbirthdaye(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="birthdaye"
                                                        placeholder=""
                                                    />


                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="idcard"
                                                        className="text-end form-label px-1 ">
                                                        شماره شناسنامه / ثبت
                                                    </label>
                                                    <input
                                                        tabIndex="11"
                                                        type="number"
                                                        value={idcard ? idcard : null}
                                                        onChange={(e) => setIdcard(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="idcard"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="father_name"
                                                        className="text-end form-label px-1 ">
                                                        محل صدور
                                                    </label>
                                                    <input
                                                        tabIndex="12"
                                                        type="text"
                                                        value={placeofissue ? placeofissue : null}
                                                        onChange={(e) => setPlaceofissue(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="father_name"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="postalcode"
                                                        className="text-end form-label px-1 ">
                                                        کد پستی
                                                    </label>
                                                    <input
                                                        tabIndex="13"
                                                        type="number"
                                                        value={postalcode ? postalcode : null}
                                                        onChange={(e) => setPostalcode(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="postalcode"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className='col-12 col-md-6'>
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="address"
                                                        className="text-end form-label px-1 ">
                                                        آدرس محل سکونت
                                                    </label>
                                                    <input
                                                        tabIndex="14"
                                                        type="text"
                                                        value={address ? address : null}
                                                        onChange={(e) => setAddress(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="address"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            </div>
                            <div className="row g-2 mb-5">
                                <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto p-0">
                                    <button
                                        tabIndex='17'
                                        onClick={documentUpdateHandler}
                                        type="submit"
                                        className="print-no rahpardaznet-btn">
                                        {'ویرایش درخواست'}
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        (status === false && message != "") ? (
                            <div className='alert alert-danger text-center'>{message ? message : null}</div>
                        ) : null
                    )
                ) : (
                    (status === false && message != "") ? (
                        <div className='alert alert-danger text-center'>{message}</div>
                    ) : null
                )
            }
        </>
    )
}

export default Edit;